import { For } from 'solid-js'

type Props<T extends string> = {
  tabs: { id: T; label: string }[]
  active: T
  onSelect: (id: T) => void
  class?: string
}

/**
 * 狭い画面で実況と番組表を切り替えるタブ。
 * 1 画面に収めるため、両方を同時には出さない。
 */
export const PanelTabs = <T extends string>(props: Props<T>) => {
  return (
    <div
      role="tablist"
      class={`flex shrink-0 gap-1 border-b border-ch-border ${props.class ?? ''}`}
    >
      <For each={props.tabs}>
        {(tab) => (
          <button
            type="button"
            role="tab"
            aria-selected={props.active === tab.id}
            onClick={() => props.onSelect(tab.id)}
            class="-mb-px border-b-2 px-3 py-2 text-xs font-semibold tracking-wide transition-colors"
            classList={{
              'border-ch-accent text-ch-text': props.active === tab.id,
              'border-transparent text-ch-dim hover:text-ch-muted': props.active !== tab.id,
            }}
          >
            {tab.label}
          </button>
        )}
      </For>
    </div>
  )
}
